import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'csn-signout',
  templateUrl: './signout.component.html',
  styleUrls: ['./signout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignoutComponent implements OnInit {


  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
    ) {}

  ngOnInit(): void {
    this.authenticationService.logout();
    this.router.navigateByUrl('/');
  }


}
